export function setHighlighted(feature) {
	return {
    type: 'SET_HIGHLIGHTED',
    data: feature
  };
}
